import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d4d7012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "card__form__button"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Cambiar contraseña")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestPasswordReset && _ctx.requestPasswordReset(...args)), ["prevent"])),
        class: "card__form"
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("input", {
            class: "card__form__input",
            type: "text",
            value: _ctx.resetEmail,
            placeholder: "Email"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            class: "card__form__input",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
            placeholder: "New Password"
          }, null, 512), [
            [_vModelText, _ctx.newPassword]
          ])
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            class: "card__form__input",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPasswordConfirmation) = $event)),
            placeholder: "New Password Confirmation"
          }, null, 512), [
            [_vModelText, _ctx.newPasswordConfirmation]
          ])
        ]),
        _hoisted_4
      ], 32)
    ])
  ]))
}